export function hasSecondaryVin(value: string | null | undefined): boolean {
  if (value == null) {
    return false;
  }
  return String(value).trim() !== '';
}

/** True when search text matches the primary or secondary VIN (case-insensitive substring). */
export function matchesVinSearch(
  searchText: string,
  vin: string | null | undefined,
  secondaryVin?: string | null
): boolean {
  const needle = searchText.toLowerCase();

  if (vin?.toLowerCase().includes(needle)) {
    return true;
  }

  return hasSecondaryVin(secondaryVin) && String(secondaryVin).toLowerCase().includes(needle);
}
